module.exports = __webpack_public_path__ + "img/add_btn_icon111.cd992439.svg";